module.exports = __webpack_public_path__ + "img/title_0.52fad249.png";